import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const youtubeAnalytics = createAsyncThunk('youtubeAnalytics/youtubeAnalytics', async (data) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `youtube_analytic`,
            params: {
                youtube_url: data.url,
                profile_analytic_id: data.profile_analytic_id,
                user_id:localStorage.getItem("id")
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})

const youtubeAnalyticsSlice = createSlice({
    name: 'youtubeAnalytics',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(youtubeAnalytics.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(youtubeAnalytics.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
                state.error = null;
            } else if (action?.payload?.status === 401) {
                state.data = null;
                state.error = 'Unauthorized';
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.error = action.payload?.data?.message || 'Failed to fetch link analysis';
                state.data = null;
            }
        });
        builder.addCase(youtubeAnalytics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || 'An error occurred';
            state.data = null;
        });
    }
})

export default youtubeAnalyticsSlice.reducer;

